import type { Destination, Language } from '../types'
import type { PlaceProvider, PlaceSearchResponse } from './PlaceProvider'

const demoPlaces: Destination[] = [
  { id: 'demo-myeongdong-station', name: '명동역', nameKo: '명동역', nameEn: 'Myeongdong Station', address: '서울특별시 중구 퇴계로 지하 126', latitude: 37.560989, longitude: 126.986325, category: 'subway_station', coordinateStatus: 'DEMO_ONLY', provider: 'DemoPlacesProvider' },
  { id: 'demo-gyeongbokgung', name: '경복궁', nameKo: '경복궁', nameEn: 'Gyeongbokgung Palace', address: '서울특별시 종로구 사직로 161', latitude: 37.579617, longitude: 126.977041, category: 'tourist_attraction', coordinateStatus: 'DEMO_ONLY', provider: 'DemoPlacesProvider' },
  { id: 'demo-olive-young-myeongdong', name: '올리브영 명동', nameKo: '올리브영 명동', nameEn: 'Olive Young Myeongdong', address: '서울특별시 중구 명동 일대 · 데모 좌표', latitude: 37.5631, longitude: 126.985, category: 'store', coordinateStatus: 'DEMO_ONLY', provider: 'DemoPlacesProvider' },
  { id: 'demo-haeundae', name: '해운대 해수욕장', nameKo: '해운대 해수욕장', nameEn: 'Haeundae Beach', address: '부산광역시 해운대구 해운대해변로 264 · 데모 좌표', latitude: 35.1587, longitude: 129.1604, category: 'beach', coordinateStatus: 'DEMO_ONLY', provider: 'DemoPlacesProvider' },
  { id: 'demo-gwangalli', name: '광안리 해수욕장', nameKo: '광안리 해수욕장', nameEn: 'Gwangalli Beach', address: '부산광역시 수영구 광안해변로 일대 · 데모 좌표', latitude: 35.1532, longitude: 129.1187, category: 'beach', coordinateStatus: 'DEMO_ONLY', provider: 'DemoPlacesProvider' },
  { id: 'demo-cinema-center', name: '영화의전당', nameKo: '영화의전당', nameEn: 'Busan Cinema Center', address: '부산광역시 해운대구 수영강변대로 120 · 데모 좌표', latitude: 35.171, longitude: 129.127, category: 'culture', coordinateStatus: 'DEMO_ONLY', provider: 'DemoPlacesProvider' },
  { id: 'demo-pknu', name: '부경대학교 대연캠퍼스', nameKo: '부경대학교 대연캠퍼스', nameEn: 'Pukyong National University, Daeyeon Campus', address: '부산광역시 남구 용소로 45 · 데모 좌표', latitude: 35.1339, longitude: 129.1038, category: 'university', coordinateStatus: 'DEMO_ONLY', provider: 'DemoPlacesProvider' },
]

function normalized(value: string): string {
  return value.toLocaleLowerCase().replace(/[\s.,-]/g, '')
}

export class DemoPlacesProvider implements PlaceProvider {
  readonly name = 'DemoPlacesProvider'

  async search(query: string, language: Language): Promise<PlaceSearchResponse> {
    const tokens = normalized(query)
    const matches = demoPlaces.filter((place) => {
      const haystack = normalized([place.name, place.nameKo, place.nameEn, place.address].filter(Boolean).join(' '))
      return haystack.includes(tokens) || tokens.includes(normalized(place.nameKo ?? place.name))
    }).slice(0, 3).map((place) => ({
      ...place,
      name: language === 'ko' ? (place.nameKo ?? place.name) : (place.nameEn ?? place.name),
    }))

    return {
      candidates: matches,
      mode: 'demo',
    }
  }
}
